import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@lenovo/material/dialog';
import { Observable } from 'rxjs';

@Component({
	selector: 'vtr-modal-wait',
	templateUrl: './modal-wait.component.html',
	styleUrls: ['./modal-wait.component.scss'],
})
export class ModalWaitComponent implements OnInit, OnDestroy {
	private shouldCloseModalSubscription: any;

	@Input() modalTitle: string;
	@Input() modalDescription: string;
	@Input() shouldCloseModal: Observable<boolean>;

	@Input() ItemParent: string;
	@Input() CancelItemName: string;

	constructor(private dialogRef: MatDialogRef<ModalWaitComponent>) {}

	ngOnInit() {
		this.shouldCloseModalSubscription = this.shouldCloseModal.subscribe((result) => {
			if (result) {
				this.closeModal('done');
			} else {
				// As the GetItemsToScan call to Plugin didn't work as expected, we are closing
				// the modal as the user clicked in the X button.
				this.closeModal('cancel');
			}
		});
	}

	ngOnDestroy() {
		if (this.shouldCloseModalSubscription) {
			this.shouldCloseModalSubscription.unsubscribe();
		}
	}

	public closeModal(info: string) {
		this.dialogRef.close(info);
	}
}
